import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div className="screen">
      <div
        className="screen-card"
        role="group"
        aria-labelledby="about-title"
      >
        <div id="about-title" className="section-title">
          Tentang aplikasi
        </div>
        <div className="subtitle">
          Aplikasi ini membantu keluarga memilih lokasi suntik insulin dengan cara yang
          ramah anak.
        </div>
        <p>
          Tampilan warna‑warni, bentuk membulat, dan animasi ringan dirancang supaya anak
          merasa lebih tenang dan terbantu saat belajar rutinitas cek gula dan suntik.
        </p>
        <p>
          Selalu ikuti arahan dokter dan tenaga kesehatan. Aplikasi ini hanya sebagai
          alat bantu visual, bukan pengganti saran medis profesional.
        </p>
        <p>
          <Link to="/">Kembali ke beranda</Link>
        </p>
      </div>
    </div>
  );
}
